import React from "react";

export default function AdjustHandle({ isCollapsed, toggleResize }) {
  return (
    <button
      className="adjust-handle"
      onDoubleClick={() => isCollapsed.set(!isCollapsed.val)}
      onMouseDown={(e) => {
        if (isCollapsed.val) isCollapsed.set(false);
        toggleResize(e);
      }}
    >
      {[...Array(3)].map((_, index) => (
        <span key={index} />
      ))}
    </button>
  );
}
